export enum API_STATUS_CODE {
  SUCCESS = 1,
  ERROR = 0,
  BUSINESS_ERROR = 2,
}
export const ipifyClientsIp = "https://api.ipify.org?format=json";
export const LI_API_BASE_URL = process.env.REACT_APP_LI_API_BASE_URL;
export const MF_API_BASE_URL = process.env.REACT_APP_MF_API_BASE_URL;
export const ABFSSL_API_BASE_URL = process.env.REACT_APP_ABFSSL_API_BASE_URL;
export const LOGIN_SERVICE_API_BASE_URL =
  process.env.REACT_APP_LOGIN_SERVICE_API_BASE_URL;
export const HI_API_BASE_URL = process.env.REACT_APP_HI_API_BASE_URL;
export const STOCKS_API_BASE_URL = process.env.REACT_APP_STOCK_API_BASE_URL;
export const ABFL_API_BASE_URL = process.env.REACT_APP_ABFL_BASE_URL;
export const HL_API_BASE_URL = process.env.REACT_APP_HL_API_BASE_URL;
export const BASE_URL = process.env.REACT_APP_ABCD_SUPERAPP_URL;
export const ABCD_HOLDINGS_API_BASE_URL =
  process.env.REACT_APP_ABCD_HOLDINGS_API_BASE_URL;
export const KYP_API_BASE_URL = process.env.REACT_APP_KYP_API_BASE_URL;

export const Api_Web_Deployment_Version =
  ABFSSL_API_BASE_URL + `/utility/fetch-last-web-deployment-version`;
export const Api_GenerateToken = ABFSSL_API_BASE_URL + `/auth/generate-token`;
export const Api_GenerateTokenV2 =
  ABFSSL_API_BASE_URL + `/auth/generate-token-v2`;
export const Api_GenerateInternalToken =
  ABFSSL_API_BASE_URL + `/auth/generate-internal-token`;
export const Api_FetchCaseStatus =
  LOGIN_SERVICE_API_BASE_URL + `/onboard/fetch-case-status`;
export const Api_GenerateOtp =
  LOGIN_SERVICE_API_BASE_URL + `/onboard/generate-otp`;
export const Api_ValidateOtp =
  LOGIN_SERVICE_API_BASE_URL + `/onboard/validate-otp`;
export const Api_SaveCrossSellContent =
  LOGIN_SERVICE_API_BASE_URL + "/onboard/save-cross-sell-consent";
export const Api_GetCustomerLobDetails =
  ABFSSL_API_BASE_URL + `/abfssl/fetch-customer-and-lob-details`;
export const Api_GetCustomerLobDetailsV2 =
  ABFSSL_API_BASE_URL + `/abfssl/fetch-customer-and-lob-details-v2`;
export const Api_FetchConsent = ABFSSL_API_BASE_URL + `/abfssl/fetch-consent`;
export const Api_CheckMobilePermission =
  ABFSSL_API_BASE_URL + `/permission/check-mobile-permission`;
export const Api_UpdateUserPermission =
  ABFSSL_API_BASE_URL + `/permission/save-or-update-user-permission`;
export const Api_SaveConsent = ABFSSL_API_BASE_URL + `/abfssl/save-consent`;
export const Api_CreateMpin =
  ABFSSL_API_BASE_URL + `/mpin-management/create-mpin`;
export const Api_ValidateMpin =
  ABFSSL_API_BASE_URL + `/mpin-management/validate-mpin`;
export const Api_UpdateMpin =
  ABFSSL_API_BASE_URL + `/mpin-management/update-mpin`;
export const Api_Register_Biometric =
  ABFSSL_API_BASE_URL + `/bm/save-biometric`;
export const Api_Mpin_Exist =
  ABFSSL_API_BASE_URL + `/mpin-management/check-mpin-exists`;
export const Api_Mpin_Validate =
  ABFSSL_API_BASE_URL + `/mpin-management/validate-mpin`;
export const Api_Mpin_Forget =
  ABFSSL_API_BASE_URL + `/mpin-management/forget-mpin`;
export const Api_TeraDataUserRegistration =
  ABFSSL_API_BASE_URL + `/abfssl/teradata-user-registration`;
export const Api_FetchConfigData =
  ABFSSL_API_BASE_URL + `/utility/fetch-config-data`;
export const Api_FileUpload = ABFSSL_API_BASE_URL + `/utility/sr/submit`;
export const Api_FetchPopularService =
  ABFSSL_API_BASE_URL + `/abfssl/fetch-popular-services`;
export const Api_FetchSearchHistory =
  ABFSSL_API_BASE_URL + `/abfssl/fetch-search-history`;
export const Api_FetchSearchBarContent =
  ABFSSL_API_BASE_URL + `/abfssl/fetch-search-bar-content`;
export const Api_SaveSearchHistory =
  ABFSSL_API_BASE_URL + `/abfssl/save-search-history`;
export const Api_ClearSearchHistory =
  ABFSSL_API_BASE_URL + `/abfssl/clear-search-history`;
export const Api_FetchMasterData =
  ABFSSL_API_BASE_URL + "/abfssl/fetch-master-data";
export const Api_SaveHoldings = ABFSSL_API_BASE_URL + "/abfssl/save-holdings";
export const Api_CheckCiiExistsForMobileEmail =
  ABFSSL_API_BASE_URL + "/abfssl/check-login-id";
export const Api_MapLobProduct =
  ABFSSL_API_BASE_URL + "/abfssl/map-lob-product";
export const Api_CheckLoginId = ABFSSL_API_BASE_URL + `/abfssl/check-login-id`;
export const Api_FetchProfile_Details =
  ABFSSL_API_BASE_URL + `/abfssl/fetch-profile-details`;
export const Api_SaveCampaignDetails =
  ABFSSL_API_BASE_URL + `/permission/save-campaign-details`;
export const Api_GenerateLmsLead =
  ABCD_HOLDINGS_API_BASE_URL + `/abcd/lms-lead-generation`;
export const Api_LmsLeadRedirection =
  ABCD_HOLDINGS_API_BASE_URL + `/abcd/lms-lead-redirection`;
export const Api_SaveUnifiedOfferDetails =
  ABFSSL_API_BASE_URL + `/abfssl/save-unified-offer-details`;
export const Api_SaveUnifiedOfferAndPromotionalCardDetails =
  ABFSSL_API_BASE_URL + `/abfssl/save-banner-details`;

export const Api_ValidateSso_New =
  LOGIN_SERVICE_API_BASE_URL + "/access-management/validate-internal-sso-token";
export const Api_GenerateSso_New =
  LOGIN_SERVICE_API_BASE_URL + "/access-management/generate-internal-sso-token";
export const Api_GenerateSso_Old =
  LOGIN_SERVICE_API_BASE_URL + "/access-management/generate-sso-token";
export const Api_ValidateSso_Old =
  LOGIN_SERVICE_API_BASE_URL + "/access-management/validate-sso-token";
export const Api_Update_User_Profile =
  BASE_URL + `/generalapp/abfssl/update-profile-details`;
export const Api_GenAppSaveNpsFeedback =
  BASE_URL + `/generalapp/abfssl/save-nps-feedback`;
export const Api_Fetch_User_Permission =
  BASE_URL + `/generalapp/permission/fetch-user-permission`;
export const Api_SaveCustomerNavigation =
  BASE_URL + `/generalapp/abfssl/save-customer-navigation`;
export const Api_Fetch_User_Profile =
  BASE_URL + `/apiadmin/admin/fetch-user-profile`;
export const Api_Update_User_Permission =
  BASE_URL + `/generalapp/permission/save-or-update-user-permission`;
export const Api_App_Version =
  BASE_URL + `/generalapp/abfssl/check-app-version`;
export const HomeLoanIdentifier = BASE_URL + `/hl/hl/home-loan-identifier`;
export const Api_SaveChatBotActivity =
  BASE_URL + `/generalapp/abfssl/save-update-simplifi-details`;
export const Api_SaveInsuranceActivity =
  ABCD_HOLDINGS_API_BASE_URL + `/abcd/save-insurance-journey`;
export const Api_UnifiedOfferDetails =
  BASE_URL + `/generalapp/abfssl/unified-offer-details`;
export const Api_Delete_Secoundary_Holding =
  BASE_URL + `/generalapp/abfssl/delete-holdings`;
export const Api_FetchTaxCenterMenu =
  BASE_URL + `/apiadmin/admin/fetch-tax-menu`;
//Exception api
export const Api_SaveUiException =
  BASE_URL + `/generalapp/exception/save-ui-exception`;

// life Insurance APIs
export const Api_FetchDashboardDetails =
  LI_API_BASE_URL + `/li/fetch-dashboard-details`;
export const Api_FetchPolicyAllDetails =
  LI_API_BASE_URL + `/li/fetch-policy-all-details`;
export const Api_DownloadTaxCertificate =
  LI_API_BASE_URL + `/li/post-certificate`;
export const APi_DownloadPolicyAccountStatement =
  LI_API_BASE_URL + `/li/policy-account-statement`;
export const Api_FetchPolicyDetails =
  LI_API_BASE_URL + `/li/fetch-policy-details`;
export const Api_FetchFundDetails = LI_API_BASE_URL + `/li/fund-details`;
export const Api_FetchAnnuityDetails =
  LI_API_BASE_URL + `/li/fetch-annuity-details`;
export const Api_FetchPolBankDetails = LI_API_BASE_URL + `/li/pol-bank-details`;
export const Api_FetchBondPolicy = LI_API_BASE_URL + `/li/fetch-bond-policy`;
export const Api_FetchPastPaymentDetails =
  LI_API_BASE_URL + `/li/past-payment-details`;
export const Api_DownloadPremium_Receipt =
  LI_API_BASE_URL + `/li/fetch-premium-receipt`;
export const Api_FetchPremium_Receipt_WithDate =
  LI_API_BASE_URL + `/li/fetch-premium-receipt-with-date`;
export const Api_LogOut = ABFSSL_API_BASE_URL + `/auth/logout`;
export const Api_RateUs = ABFSSL_API_BASE_URL + `/abfssl/save-rating`;
export const Api_SendEmail = LI_API_BASE_URL + `/li/send-document-email`;
export const Api_SendWhatsApp = LI_API_BASE_URL + `/li/send-document-whatsapp`;
export const Api_WhatsappOpt = LI_API_BASE_URL + `/li/whatsapp-opt-inout`;
export const Api_FetchLiCaseQueryCrm = LI_API_BASE_URL + `/li/case-query-crm`;
export const Api_FetchRecentUpdates =
  LI_API_BASE_URL + `/li/fetch-recent-updates`;
export const Api_FetchNSDLPANDetails =
  LI_API_BASE_URL + `/li/fetch-nsdl-pan-details?recordsCount=1`;
export const Api_CrmCaseCreate = LI_API_BASE_URL + `/li/crm-case-create`;
export const Api_LiUploadDoc = LI_API_BASE_URL + `/li/upload-doc`;
export const Api_LiGetOtp = LI_API_BASE_URL + `/li/get-otp`;
export const Api_LiValidateOtp = LI_API_BASE_URL + `/li/validate-otp`;
export const Api_LiGetBankName = LI_API_BASE_URL + `/li/get-bank-name`;
export const Api_LiKarzaBankAccount = LI_API_BASE_URL + `/li/karza-imps`;
export const Api_LiFundDetails = LI_API_BASE_URL + `/li/fund-details`;
export const Api_LiSetAlertExisting =
  LI_API_BASE_URL + `/li/set-alert-existing`;
export const Api_LiWhatsappOptIn = LI_API_BASE_URL + `/li/whatsapp-opt-inout`;
export const Api_LiSaveNpsFeedback = LI_API_BASE_URL + `/li/save-nps-feedback`;
export const Api_LiNpsZoneDetails = LI_API_BASE_URL + `/li/nps-zone-details`;
export const Api_LiProfileDetails =
  LI_API_BASE_URL + `/li/fetch-li-profile-details`;
export const Api_FetchCountDetails = LI_API_BASE_URL + `/li/get-count-details`;
export const Api_FetchLiReKycStatus =
  LI_API_BASE_URL + `/li/check-rekyc-status`;
export const Api_Li_Save_Service_Request =
  LI_API_BASE_URL + "/li/save-service-request";
export const Api_Li_FetchMobileFromPolicyId =
  LI_API_BASE_URL + `/li/fetch-mobile-from-policy-id`;

//Mutual Fund APIs
export const Api_ExitLoad = MF_API_BASE_URL + `/mf/exit-load-amount`;
export const Api_DownloadCapitalStatementNew =
  MF_API_BASE_URL + `/mf/fetch-capital-gain-statement-new`;
export const Api_ValidatePan = MF_API_BASE_URL + `/mf/validate-pan`;
export const Api_FoliosSummary =
  MF_API_BASE_URL + `/mf/fetch-portfolio-by-folio`;
export const APi_FolioSchemeSummary =
  MF_API_BASE_URL + `/mf/fetch-folio-scheme-summary`;
export const Api_AccountStatementNew =
  MF_API_BASE_URL + `/mf/fetch-account-statement-new`;
export const Api_LastTransactionBroker =
  MF_API_BASE_URL + `/mf/last-transaction-broker`;
export const Api_FolioLinkingDelinking =
  MF_API_BASE_URL + `/mf/folio-linking-delinking`;
export const Api_DelinkFolioList = MF_API_BASE_URL + `/mf/delink-folio-list`;

//health Insurance Apis
export const Api_FetchPolicyDetailsByMobileNumber =
  HI_API_BASE_URL + `/hi/policy-details-by-mobile-number`;
export const Api_PolicyInsured = HI_API_BASE_URL + `/hi/insured-policy-api`;
export const Api_DownloadECard = HI_API_BASE_URL + `/hi/e-card-download`;
export const Api_DownloadPolicyDocs =
  HI_API_BASE_URL + `/hi/omni-docs-search-and-download`;
export const Api_DownloadPolicyWording = HI_API_BASE_URL + `/hi/policy-wording`;
export const Api_UpdateHIDetails = HI_API_BASE_URL + `/hi/case-create`;
export const Api_ViewCaseHi = HI_API_BASE_URL + `/hi/view-case`;
export const Api_Save_Service_Request =
  HI_API_BASE_URL + "/hi/save-service-request";
export const Api_Sfdc_Case_Create = HI_API_BASE_URL + "/hi/sfdc-case-create";

///stock api
export const API_FetchPortfolio =
  STOCKS_API_BASE_URL + `/stocks/fetch-portfolio-from-pan-or-mobile`;
export const API_FetchHoldingsFromClientId =
  STOCKS_API_BASE_URL + `/stocks/fetch-holdings-from-userid`;
export const API_DownloadStatementOfTransaction =
  STOCKS_API_BASE_URL + `/stocks/fetch-aditya-financial-statement-pdf`;
export const API_CapitalGainStatementDownload =
  STOCKS_API_BASE_URL + `/stocks/fetch-capital-gain`;
export const API_DownloadStatementOfAccount =
  STOCKS_API_BASE_URL + `/stocks/fetch-cash-info-statement`;
export const API_DownloadContractNote =
  STOCKS_API_BASE_URL + `/stocks/fetch-contract-file-pdf`;

// CMS
export const APi_CMS_PageVariables = BASE_URL + `/specs/cms/page-variables`;
export const APi_CMS_IntegrationVariables =
  BASE_URL + `/specs/cms/integration-variables`;
export const APi_CMS_ErrorDetails = BASE_URL + `/specs/cms/fetch-error-details`;
export const APi_CMS_RateUsContent = BASE_URL + `/specs/cms/rate-us`;
export const API_CMS_FAQ_Parent_ModuleList =
  BASE_URL + `/specs/cms/parent-modules`;
export const API_CMS_FAQ_ModuleList = BASE_URL + `/specs/cms/modules`;
export const API_CMS_FAQ_CategoryList = BASE_URL + `/specs/cms/faq-categories`;
export const API_CMS_FAQ_List = BASE_URL + `/specs/cms/faqs`;
export const Api_CMS_PageMessages = BASE_URL + `/specs/cms/page-messages`;
export const Api_CMS_NpsFeedBack = BASE_URL + `/specs/cms/nps-feedback`;
export const Api_HL_SuccessMessages =
  BASE_URL + `/specs/cms/home-loan-success-messages`;
export const Api_CMS_ClaimProcessDocument =
  BASE_URL + `/specs/cms/claim-process-documents`;
export const Api_Fetch_My_Track = BASE_URL + `/specs/cms/fetch-my-track`;
export const Api_Fetch_Top_Banner = BASE_URL + `/specs/cms/fetch-top-banner`;
export const Api_Fetch_Center_Banner =
  BASE_URL + `/specs/cms/fetch-center-banner`;
export const Api_Fetch_New_Offering =
  BASE_URL + `/specs/cms/fetch-new-offerings`;
export const Api_Fetch_Footer_Banner =
  BASE_URL + `/specs/cms/fetch-footer-banner`;
export const Api_Fetch_L2_Banner = BASE_URL + `/specs/cms/fetch-l2-banner`;
export const Api_Fetch_Nudge_Banner =
  BASE_URL + `/specs/cms/fetch-nudge-banner`;
export const Api_CMS_Onboarding_Animation =
  BASE_URL + `/specs/cms/fetch-onboarding-animations`;

// home loan API
export const Api_Dataservice = HL_API_BASE_URL + `/data-services`;
export const Api_Fetchlan = HL_API_BASE_URL + `/fetch-lan`;
export const Api_ChangeEmail = HL_API_BASE_URL + `/change-email`;
export const Api_CreateCase = HL_API_BASE_URL + `/create-case`;
export const Api_ReportingService = HL_API_BASE_URL + `/reporting-service`;
export const Api_WelcomeKitService = HL_API_BASE_URL + `/welcome-kit-download`;
export const Api_Create_Order = HL_API_BASE_URL + `/create-order`;
export const Api_Order_Status = HL_API_BASE_URL + `/order-status`;
export const Api_Create_Case_Query_Multiple =
  HL_API_BASE_URL + `/create-case-query-multiple`;
export const Api_Create_Case_Query = HL_API_BASE_URL + `/create-case-query`;
export const Api_Customer_Info = HL_API_BASE_URL + `/customer-info`;
export const Api_FetchHLEmailCount = HL_API_BASE_URL + `/get-count-details`;
export const Api_FetchHLAdvanceEMI_Payment_Detail =
  HL_API_BASE_URL + `/fetch-emi-payment-details`;
export const Api_FetchHLRoiHistory = HL_API_BASE_URL + `/fetch-roi-history`;
export const Api_HomeLoan_Generate_Otp = HL_API_BASE_URL + "/generate-otp";
export const Api_HomeLoan_Validate_Otp = HL_API_BASE_URL + "/validate-otp";
export const Api_Fetch_PDD_Information =
  HL_API_BASE_URL + "/fetch-pdd-information";

//ABCD Holdings API
export const Api_FetchUserProductStatus =
  ABCD_HOLDINGS_API_BASE_URL + `/abcd/fetch-user-product-status`;
export const Api_FetchUserTransactionStatus =
  ABCD_HOLDINGS_API_BASE_URL + `/abcd/fetch-user-transaction-status`;
export const Api_DownloadMotorPolicyDocument =
  ABCD_HOLDINGS_API_BASE_URL + `/abcd/download-motor-policy-document`;
export const Api_FetchPocketInsurancePolicyDocument =
  ABCD_HOLDINGS_API_BASE_URL + `/abcd/fetch-pocket-insurance-policy-document`;
export const Api_FetchTravelInsurancePolicyDocument =
  ABCD_HOLDINGS_API_BASE_URL + `/abcd/fetch-travel-insurance-policy-document`;

//Know Your Policy API
export const Api_KnowYourPolicyFileUpload =
  KYP_API_BASE_URL + `/api/v1/internal/documents/upload`;

export const Api_SaveVerifiedPanDetails =
  ABFL_API_BASE_URL + "/save-verified-pan-details";
export const Api_FetchVerifiedPanDetails =
  ABFL_API_BASE_URL + "/fetch-verified-pan-details";
